import { Card } from '@qonsoll/react-design'
import PropTypes from 'prop-types'
import { cardStyles } from './SelectableCard.styled'

/**
 * If the card is selected, use the selected styles, otherwise use the default styles.
 * @param isSelected {boolean} - If true, the card is selected
 * @param onSelect {function} - The function to call when the card is selected
 */
const SelectableCard = (props) => {
  const { isSelected, onSelect, children } = props

  // [COMPUTED_PROPERTIES]
  const styles = isSelected ? cardStyles.selected : cardStyles.default

  return (
    <Card onClick={onSelect} bodyStyle={styles}>
      {children}
    </Card>
  )
}

SelectableCard.propTypes = {
  isSelected: PropTypes.bool,
  onSelect: PropTypes.func,
  children: PropTypes.node
}

export default SelectableCard
